import toast from 'react-hot-toast';

let activeToastId = null;
let toastTimeout = null;

const showToast = (status, message, duration = 3000) => {
    if (activeToastId) return; // Don't show new toast if one is active

    const commonStyles = {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        padding: '10px',
    };

    const toastOptions = {
        duration,
        style: {},
    };

    // Clear toastId after timeout
    const setToastCleanup = () => {
        clearTimeout(toastTimeout);
        toastTimeout = setTimeout(() => {
            activeToastId = null;
        }, duration);
    };

    switch (status) {
        case 'success':
            toastOptions.style = { ...commonStyles, backgroundColor: '#6ebe44', color: '#fff' };
            activeToastId = toast.success(message, toastOptions);
            break;

        case 'error':
            toastOptions.style = { ...commonStyles, backgroundColor: '#f44336', color: '#fff' };
            activeToastId = toast.error(message, toastOptions);
            break;

        case 'loading':
            toastOptions.style = { ...commonStyles, backgroundColor: '#4D96FF', color: '#fff' };
            activeToastId = toast.loading(message, toastOptions);
            break;

        case 'warning':
            toastOptions.icon = '⚠️';
            toastOptions.style = { ...commonStyles, backgroundColor: '#FF5F15', color: '#000' };
            activeToastId = toast(message, toastOptions);
            break;

        case 'custom':
            toastOptions.style = commonStyles;
            activeToastId = toast(message, toastOptions);
            break;

        default:
            toastOptions.style = commonStyles;
            activeToastId = toast(message, toastOptions);
    }

    setToastCleanup(); // Clean up after toast duration
};

export default showToast;
